import Vue from 'vue'
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
// import 'https://resources.interface003.com/web20/css/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import {
  Button,
  Dialog,
  Switch,
  Upload,
  Input,
  Carousel,
  CarouselItem,
  Popover,
  Rate,
  Select,
  Option,
  OptionGroup,
  Autocomplete,
  Collapse,
  CollapseItem,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
  Image,
  Table,
  TableColumn,
  DatePicker,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Pagination,
  Message,
  Drawer,
  TimeSelect
} from 'element-ui'

const components = [
  Button,
  Dialog,
  Switch,
  Upload,
  Input,
  Carousel,
  CarouselItem,
  Popover,
  Rate,
  Select,
  Option,
  OptionGroup,
  Autocomplete,
  Collapse,
  CollapseItem,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
  Image,
  Table,
  TableColumn,
  DatePicker,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Pagination,
  Message,
  CollapseTransition,
  Drawer,
  TimeSelect
]
Vue.prototype.$message = Message

const Element = {
  install (Vue) {
    components.forEach((component) => {
      Vue.component(component.name, component)
    })
  }
}
// 设置语言
locale.use(lang)
Vue.use(Element)
